import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useApp } from '../context/AppContext';

export default function TimingHelper({ flightTime, bagWait, driveTime = 25, isCompanion = false }) {
  const { grantXp } = useApp();
  const [onMyWay, setOnMyWay] = useState(false);
  const landingDate = new Date(flightTime);
  const leaveTime = new Date(landingDate.getTime() - (driveTime - bagWait) * 60000);

  const handleOnWay = () => {
    setOnMyWay(true);
    grantXp(25, 'Coordination confirmed!');
  };

  return (
    <div className="bg-slate-900/50 rounded-xl p-4 border border-slate-800">
      <h4 className="text-xs font-bold text-slate-400 uppercase mb-3 flex items-center">
        <SafeIcon icon={FiIcons.FiClock} className="mr-1.5 text-amber-500" />
        Pickup Timing Helper
      </h4>
      
      <div className="flex items-center justify-between space-x-2">
        <div className="text-center flex-1">
          <p className="text-[10px] text-slate-500 uppercase">Leave Home</p>
          <p className="font-mono text-amber-400 font-bold">
            {leaveTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
        <SafeIcon icon={FiIcons.FiChevronRight} className="text-slate-700" />
        <div className="text-center flex-1">
          <p className="text-[10px] text-slate-500 uppercase">Landing</p>
          <p className="font-mono text-white">
            {landingDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
        <SafeIcon icon={FiIcons.FiChevronRight} className="text-slate-700" />
        <div className="text-center flex-1">
          <p className="text-[10px] text-slate-500 uppercase">Bags Ready</p>
          <p className="font-mono text-emerald-400">
            {new Date(landingDate.getTime() + bagWait * 60000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </p>
        </div>
      </div>
      
      {isCompanion && (
        <div className="mt-4 pt-4 border-t border-slate-800 flex gap-2">
          {!onMyWay ? (
            <>
              <button 
                onClick={handleOnWay}
                className="flex-1 bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold py-2.5 rounded-lg transition-all"
              >
                On My Way
              </button>
              <button className="px-4 bg-slate-800 text-slate-400 text-xs font-bold py-2.5 rounded-lg">
                Snooze 10m
              </button>
            </>
          ) : (
            <div className="w-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 text-xs font-bold py-2.5 rounded-lg text-center flex items-center justify-center space-x-2">
              <SafeIcon icon={FiIcons.FiCheck} />
              <span>Traveler Notified: You're on the way!</span>
            </div>
          )}
        </div>
      )}

      <div className="mt-4 pt-3 border-t border-slate-800/50 flex justify-between items-center text-[10px]">
        <span className="text-slate-500 italic">Based on {driveTime}m drive + {bagWait}m bag claim</span>
        <button className="text-amber-500 font-bold hover:underline">Adjust Drive Time</button>
      </div>
    </div>
  );
}